import { SVGProps, Ref, forwardRef } from 'react';

export const FlagFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8 1.256c1.622.552 3.245 1.104 5.6.48q.415-.11.864-.272L15 2v9.744c-3.15 1.31-5.075.655-7 0-1.622-.552-3.245-1.104-5.6-.48v4.233H1V1.257C4.15-.054 6.075.6 8 1.255"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlagFilledSize16Glyph.displayName = 'FlagFilledSize16Glyph';
